import createPersistedState from "vuex-persistedstate";
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import setting from "./modules/setting";
import data from "./modules/data";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    setting,
    data
  },
  plugins: [
    // 持久化插件
    createPersistedState({
      storage: window.localStorage,
    }),
  ],
  getters,
});

export default store;
